import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const EloCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H31.9999C34.209 0 35.9999 1.79086 35.9999 4V20C35.9999 22.2091 34.209 24 31.9999 24H4C1.79086 24 0 22.2091 0 20V4Z'
        fill='white'
      />
      <path
        d='M8.87188 9.26366C9.14961 9.1669 9.44776 9.11642 9.75816 9.11642C11.1141 9.11642 12.2454 10.1092 12.5028 11.4259L14.4223 11.0221C13.9812 8.78409 12.0617 7.09717 9.75816 7.09717C9.23129 7.09717 8.72485 7.18551 8.25108 7.34957L8.87188 9.26366Z'
        fill='#FFF100'
      />
      <path
        d='M6.6051 15.6747L7.90388 14.1602C7.32392 13.6302 6.96042 12.8603 6.96042 11.9979C6.96042 11.1398 7.32392 10.3657 7.90388 9.83986L6.6051 8.32963C5.6208 9.22988 5 10.5382 5 12.0021C5 13.4619 5.6208 14.7744 6.6051 15.6747Z'
        fill='#00A3DF'
      />
      <path
        d='M12.5027 12.5786C12.2413 13.8954 11.1141 14.884 9.75814 14.884C9.44774 14.884 9.14959 14.8335 8.86778 14.7367L8.24698 16.6508C8.72075 16.8149 9.23128 16.9032 9.75814 16.9032C12.0616 16.9032 13.9812 15.2205 14.4223 12.9825L12.5027 12.5786Z'
        fill='#EE4023'
      />
      <path
        d='M20.818 13.9333C20.4994 14.253 20.0706 14.4466 19.5968 14.4381C19.2701 14.4339 18.9679 14.333 18.7146 14.1647L18.0775 15.208C18.5145 15.4898 19.025 15.6581 19.5805 15.6665C20.3851 15.6791 21.1203 15.351 21.6553 14.8167L20.818 13.9333ZM19.6663 9.68027C18.0653 9.65503 16.742 10.976 16.7175 12.625C16.7093 13.2434 16.8808 13.8239 17.1872 14.3035L22.4476 11.9856C22.1536 10.6857 21.0263 9.70551 19.6663 9.68027ZM17.9223 12.8606C17.9141 12.7933 17.9101 12.7218 17.9101 12.6503C17.9264 11.6785 18.7024 10.9002 19.6458 10.9171C20.1605 10.9255 20.6179 11.1653 20.9242 11.5439L17.9223 12.8606ZM24.1017 8.3341V14.11L25.0738 14.5265L24.6123 15.6665L23.6484 15.2543C23.4319 15.1575 23.2849 15.0103 23.1746 14.842C23.0684 14.6737 22.9867 14.4381 22.9867 14.1268V8.3341H24.1017Z'
        fill='black'
      />
      <path
        d='M27.61 11.0056C27.7815 10.9467 27.9612 10.9173 28.1532 10.9173C28.9823 10.9173 29.6684 11.5231 29.8277 12.3265L30.9999 12.0783C30.7303 10.7111 29.5582 9.68469 28.1532 9.68469C27.8305 9.68469 27.5201 9.73938 27.2343 9.83614L27.61 11.0056ZM26.2255 14.9137L27.0178 13.9924C26.6625 13.6685 26.4419 13.1974 26.4419 12.6715C26.4419 12.1457 26.6665 11.6745 27.0178 11.3548L26.2255 10.4335C25.6251 10.9804 25.2452 11.7839 25.2452 12.6757C25.2452 13.5675 25.6251 14.3668 26.2255 14.9137ZM29.8277 13.0291C29.6684 13.8326 28.9782 14.4384 28.1532 14.4384C27.9653 14.4384 27.7815 14.4047 27.61 14.3458L27.2302 15.5153C27.5201 15.6163 27.8305 15.6709 28.1532 15.6709C29.5582 15.6709 30.7303 14.6445 30.9999 13.2773L29.8277 13.0291Z'
        fill='black'
      />
    </svg>
  )
})
